if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        // super.show(opener);
        // this.openedBy = opener;
        // this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;
        
        const mediaId = this.openedBy.getAttribute('data-media-id');
        if (!mediaId) {
          console.log('Aucun data-media-id trouvé sur l\'élément déclencheur');
          return;
        }
        
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        
        if (!activeMedia) {
          console.log(`Aucun élément avec data-media-id="${mediaId}" trouvé dans le modal`);
          
          const mediaContainer = this.querySelector('.product-media-modal__content');
          if (mediaContainer) {
            const allMedia = this.querySelectorAll('[data-media-id]');
            if (allMedia.length > 0) {
              const firstMedia = allMedia[0];
              firstMedia.classList.add('active');
              firstMedia.scrollIntoView();
              
              const container = this.querySelector('[role="document"]');
              if (container) {
                container.scrollLeft = (firstMedia.width - container.clientWidth) / 2;
              }
              
              if (firstMedia.nodeName == 'DEFERRED-MEDIA') {
                const template = firstMedia.querySelector('template');
                if (template && template.content.querySelector('.js-youtube')) {
                  firstMedia.loadContent();
                }
              }
            }
          }
          return;
        }
        
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
